export const REQUEST_UPDATE_PROFILE = "REQUEST_UPDATE_PROFILE";
export const SUCCESS_UPDATE_PROFILE = "SUCCESS_UPDATE_PROFILE";
export const FAILURE_UPDATE_PROFILE = "FAILURE_UPDATE_PROFILE";

export const REQUEST_CHANGE_PASSWORD = "REQUEST_CHANGE_PASSWORD";
export const SUCCESS_CHANGE_PASSWORD = "SUCCESS_CHANGE_PASSWORD";
export const FAILURE_CHANGE_PASSWORD = "FAILURE_CHANGE_PASSWORD";

const CHANGE_PASSWORD_ERROR = "La contraseña actual es incorrecta";

export default (state: any, action: any) => {
  switch (action.type) {
    case REQUEST_UPDATE_PROFILE:
      return {
        ...state,
        submitSuccess: {},
        submitErrors: {}, // action.payload
      };

    case SUCCESS_UPDATE_PROFILE:
      return {
        ...state,
        submitSuccess: { update_profile: action.payload },
        submitErrors: {}, // action.payload
      };

    case FAILURE_UPDATE_PROFILE:
      return {
        ...state,
        submitSuccess: {},
        submitErrors: { update_profile: action.payload }, // action.payload
      };

    case REQUEST_CHANGE_PASSWORD:
      return {
        ...state,
        submitSuccess: {},
        submitErrors: {}, // action.payload
      };

    case SUCCESS_CHANGE_PASSWORD:
      return {
        ...state,
        submitSuccess: { change_password: action.payload },
        submitErrors: {}, // action.payload
      };

    case FAILURE_CHANGE_PASSWORD:
      return {
        ...state,
        submitSuccess: {},
        submitErrors: { change_password: CHANGE_PASSWORD_ERROR }, // action.payload
      };

    default:
      return state;
  }
};
